import { useState } from "react";
import { submitFormMutation } from "../../../data-service/forms/functions";

export const PatientStrategy = ({}) => {
  const [email, setEmail] = useState("");
  const [audience, setAudience] = useState("");
  const [billingCodeTargeting, setBillingCodeTargeting] = useState("");
  const [message, setMessage] = useState("");

  const resetFields = () => {
    setEmail("");
    setAudience("");
    setBillingCodeTargeting("");
    setMessage("");
  };

  function textFieldChange(event) {
    const { name, value } = event.target;
    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "targeting":
        setAudience(value);
        break;
      case "billingCodeTargeting":
        setBillingCodeTargeting(value);
        break;
      case "message":
        setMessage(value);
        break;
      default:
        break;
    }
  }
  return (
    <section className="section-sp2">
      <div
        className="container inner-content"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <h2>Let’s Build Your Patient Strategy</h2>
        <p>
          Tell us which patient condition you’d like to reach, and we’ll
          research the audience <br /> size and create a tailored marketing plan
          — no commitment required.
        </p>
        <div
          style={{
            maxWidth: "630px",
            boxShadow: "0px 10px 60px 0px rgba(31, 34, 120, 0.1)",
            paddingTop: "20px",
            paddingInline: "20px",
            borderRadius: "20px",
            background: "#FFFFFF",
          }}
          className=""
        >
          <div className="row">
            <div className="mb-30">
              <form
                className="form-wraper contact-form ajax-form"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const res = await submitFormMutation({
                    senderName: "",
                    email,
                    message,
                    hcpsTargeting: audience,
                    billingCodeTargeting,
                    formName: "patient-marketing",
                    pageUrl: "patient-marketing",
                  });

                  if (res.id) {
                    alert(
                      "Thank you for your interest. We will get back to you shortly."
                    );
                    resetFields();
                  }
                  console.log(email, audience, billingCodeTargeting, message);
                }}
              >
                <div className="ajax-message"></div>
                <div className="row">
                  <div className="form-group ">
                    <input
                      name="email"
                      type="email"
                      required
                      value={email}
                      className="form-control"
                      placeholder="Work Email*"
                      onChange={textFieldChange}
                    />
                  </div>
                  <div className="form-group col-md-12">
                    <input
                      name="audience"
                      type="text"
                      required
                      value={audience}
                      className="form-control"
                      placeholder="Patient Audience"
                      onChange={textFieldChange}
                    />
                  </div>
                  <div className="form-group col-md-12">
                    <input
                      name="targeting"
                      type="text"
                      value={billingCodeTargeting}
                      className="form-control"
                      placeholder="Are you using any specific billing codes?"
                      onChange={textFieldChange}
                    />
                  </div>

                  <div className="form-group col-md-12">
                    <input
                      name="message"
                      type="text"
                      value={message}
                      className="form-control"
                      placeholder="Anything else we should know?"
                      onChange={textFieldChange}
                    />
                  </div>
                  <div className="col-lg-12">
                    <button
                      name="submit"
                      type="submit"
                      defaultValue="Submit"
                      className="btn w-100 btn-secondary btn-lg"
                    >
                      Get My Custom Plan
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
